import { snapshotParams, snapshotVersionOf } from '@sb/database/snapshotParams';
import type { EnvironmentVariable } from '@sb/remote-control/types';
import { convertGlobalVariableResponse } from '@sb/remote-control/util/convertGlobalVariableResponse';

import { getGlobalVariablesService } from './utils/getGlobalVariablesService';

export async function updateGlobalVariable(
  globalVariableId: string,
  updatedVariable: EnvironmentVariable,
) {
  const saved = await getGlobalVariablesService().patch(
    globalVariableId,
    {
      globalVariableItem: {
        ...updatedVariable,
        isGlobal: true,
        persistent: updatedVariable.persistent ?? false,
      },
    },
    snapshotParams(snapshotVersionOf(updatedVariable)),
  );

  return convertGlobalVariableResponse(saved).globalVariableItem;
}
